import { createStackNavigator } from "@react-navigation/stack"
import type { ContactListCommentStackParamList } from "src/types.d"

export const ContactListCommentStack = createStackNavigator<ContactListCommentStackParamList>()
